<template>
  <layout title="Clientes" :options="options" :rotas="rotas">
    <v-sheet
      :dark="$theme.dark"
      :light="$theme.light"
      class="expande-horizontal sheet-container pt-2"
    >
      <v-flex xs12 class="pr-1" lg3>
        <Filters :filter="filter" />
        <List :filtereds="filtereds" />
        <EmptyList
          :iniciarCadastro="iniciarCadastro"
          v-if="filtereds.length === 0"
        />
        <v-fab-transition>
          <v-btn
            @click="iniciarCadastro"
            :color="$theme.primary"
            dark
            absolute
            bottom
            right
            fab
            style="bottom: 30px;"
          >
            <v-icon color="#333">mdi-plus</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-flex>
      <v-flex v-if="$vuetify.breakpoint.lgAndUp" xs12 md9 lg9>
        <ViewForm v-if="get_cliente.new || get_cliente._id" />
      </v-flex>
      <v-dialog
        v-else
        transition="slide-x-transition"
        fullscreen
        :value="get_cliente._id || get_cliente.new ? true : false"
      >
        <v-card>
          <ViewForm />
        </v-card>
      </v-dialog>
    </v-sheet>
  </layout>
</template>

<script>
import EmptyList from "../components/EmptyList.vue";
import Filters from "../components/Filters.vue";
import List from "../components/List.vue";
import ViewForm from "../components/ViewForm.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      filter: {},
      options: [
        {
          nome: "Novo cliente",
          action: this.iniciarCadastro,
          icon: "mdi-plus"
        }
      ],
      rotas: [
        {
          name: "Início",
          path: "/dashboard"
        },
        {
          name: "Clientes",
          path: "/clientes"
        }
      ]
    };
  },
  components: {
    EmptyList,
    Filters,
    List,
    ViewForm
  },
  computed: {
    ...mapGetters([
      "get_clientes_filtros",
      "getLoggedUser",
      "get_cliente",
      "get_clientes",
      "getPersonalizedLoading"
    ]),
    filtereds() {
      if (this.filter.search) {
        const search = this.filter.search.toLowerCase();
        return this.get_clientes.docs.filter(item => {
          const whatsappLinks = Array.isArray(item.whatsapp_links) ? item.whatsapp_links.map(link => link.phone || link.telefone || "").join(" ") : "";
          return (
            (item.nome &&
              item.nome
                .toLowerCase()
                .includes(search)) ||
            (item.razao_social &&
              item.razao_social
                .toLowerCase()
                .includes(search)) ||
            (item.email &&
              item.email
                .toLowerCase()
                .includes(search)) ||
            (item.cpf &&
              item.cpf
                .toLowerCase()
                .includes(search)) ||
            (item.cnpj &&
              item.cnpj
                .toLowerCase()
                .includes(search)) ||
            (item.telefone &&
              item.telefone.includes(search)) ||
            whatsappLinks.includes(search)
          );
        });
      } else {
        return this.get_clientes.docs;
      }
    }
  },
  methods: {
    excluir_cliente_dialog(item) {
      let text = "Deseja remover este cliente?";
      this.createConfirmAction({
        message: text,
        icon: "mdi-close-circle",
        action: "excluir_cliente",
        action_value: item
      });
    },
    getLinkById(id) {
      return this.getLinkById[id];
    },
    ...mapActions([
      "abre_modal_view_tenant",
      "listar_tenants",
      "listar_clientes",
      "criar_estoque",
      "listar_clientecategorias",
      "criar_cliente",
      "listar_estoques",
      "atualizar_cliente",
      "setPersonalizedLoading",
      "createConfirmAction"
    ]),
    criarOuAtualizar() {
      if (this.get_cliente._id) {
        this.atualizar_cliente();
      } else {
        this.criar_cliente();
      }
    },
    iniciarCadastro() {
      this.setPersonalizedLoading("animate__fadeOutTopRight");
      this.$store.commit("set_cliente", { new: true });
      this.$store.commit("setLinks", []);
      this.setPersonalizedLoading("animate__fadeInUp");
    },
    createOrUpdate() {
      if (this.$refs.form.validate()) {
        if (this.get_cliente._id) {
          this.atualizar_cliente();
        } else {
          this.criar_cliente();
        }
      }
    }
  },
  created() {
    this.listar_clientes();
  }
};
</script>

<style scoped>
.sheet-container {
  min-height: 95vh;
  max-height: 95vh;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.item-list {
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #1173ff;
}
</style>
